import { useEffect, useRef } from "react";

/** Confirmación antes de pasar al pago (Eduardo 2026-10-01): «Vas a inscribir
 * a NOMBRE · N años · CATEGORÍA». Va en la página (no es un diálogo) y se abre
 * solo con «Guardar datos». */
export default function RegistrationConfirmCard({
  summary,
  onConfirm,
  onCorrect,
}: {
  summary: string;
  onConfirm: () => void;
  onCorrect: () => void;
}) {
  const cardRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const card = cardRef.current;
    if (!card) return;
    card.focus({ preventScroll: true });
    card.scrollIntoView?.({ behavior: "smooth", block: "center" });
  }, []);
  return (
    <div
      ref={cardRef}
      className="public-registration-confirm-card"
      role="region"
      aria-label="Confirma la inscripción"
      tabIndex={-1}
    >
      <p className="public-registration-confirm-card__text">{summary}</p>
      <div className="public-registration-confirm-card__actions">
        <button className="button button--secondary" type="button" onClick={onCorrect}>
          Corregir
        </button>
        <button className="button button--primary" type="button" onClick={onConfirm}>
          Sí, es correcto
        </button>
      </div>
    </div>
  );
}
